/************* PROJECT *************/
// projects route
export const PROJECT_URL = "projects";
export const PROJECTS_URL = "customer"
export const USER_URL = "users";
export const LOGIN_WITH_ID_URL = "users/Disposable-auth";
export const CLICK_ON_CONTRACTOR = "projects/clicks-on-contractor-page-in-last-form-step";
export const PROJECT_TRACK_URL = "projects/track-project"

// session tracking
export const SESSION_TRACKING_URL = "session/track"

/************* COCATIONS *************/
// locations route
export const PROVINCES_URL = 'provinces'
export const CITIES_URL = 'cities'

/************* SERVICE TYPES *************/
// service types
export const SERVICE_TYPES_URL = 'service-type?is-active=true'

/************* MODELS *************/
// models
export const MODEL_URL = "models"
export const MODEL_BY_URL = "models/getByUrl"
export const MODEL_BULK_URL = "models/get-by-material-bulk-name"
export const MODEL_BY_LABEL = "models/get-by-bookmarked-model-filters"
export const MODEL_LABEL_TEMPLATE_URL = "model-label-template"

// models-categories
export const MODELS_CATEGORIES_URL = 'models-category'

// materials
export const MATERIALS_URL = 'material'

// selected contractors
export const SELECT_MODELS_URL = "projects/select-model"


/************* CONTRACTOR *************/
// contractors
export const SPECIALISTS_URL = 'client/contractors/profiles'
// contractor
export const PROFILEL_URL = 'client/contractors/'

// selected contractors
export const SELECTED_CONTRACTORS_URL = "projects/selected-contractors"

// specialist comments
export const CONTRACTOR_COMMENTS_URL = 'comments'

export const CONTRACTORS_LOGIN = 'contractors/login'

/************* SUBSCRIPTION PACKAGE *************/
// subscription package
export const GET_PACKAGES = 'member-ship-plan?limit=100';

// buy subscription package
export const BUY_PACKAGE_PAYMENT = 'contractors/request-package';

// upload base url
export const UPLOAD_BASE_URL = process.env.NEXT_PUBLIC_UPLOAD_BASE_URL

// ================= Upload service ================= //
export const UPLOAD_FILE = '/static-content/upload'
export const GET_FILE = UPLOAD_BASE_URL

// ================= Dynamic Fields ================= //
export const DYNAMIC_FIELD_URL = 'field-key-value'

// ================= Temp Comment ================= //
export const TEMP_COMMENT_URL = "comments/nps"

// ================= behsa projects ================= //
export const BEHSA_URL = process.env.NEXT_PUBLIC_BEHSA_URL
export const BEHSA_CONTRACTORS_URL = "contractor"
export const BEHSA_PROJECT_URL = "project";
export const BEHSA_USER_JOURNEY_URL = "customer-journey/customer";

// ================= Behsa Dynamic Form ================= //
export const BEHSA_DYNAMIC_OPTION_URL = 'design-sample/customer'


// ================= Contractors Comments ================= //
export const CREATE_COMMENT = "comments"
export const REPLY_COMMENT = "comments/reply"

// ================= Contractors Comments Likes ================= //
export const LIKE_COMMENT = "comments/like"
export const REMOVE_LIKE = "comments/remove-like"

// ================= Consultation Request ================= //
export const PROJECT_CONSULTATION = "projects/customer/consultation-request";

// ================= FeedBack On Contractor Request ================= //
export const FEEDBACK_ON_CONTACTOR = "customer/requests/";

// ================= Suggest more contractors Request ================= //
export const SUGGEST_MORE_CONTRACTORS = "projects/customer/suggest-more-contractors-request/";

// ================= Follow up Request ================= //
export const FOLLOW_UP_REQUEST = "projects/customer/follow-up-request/";

// get holidays
export const HOLIDAYS_URL = "holidays/isHoliday"

// ================= Follow up Request ================= //
export const PRODUCTS_URL = "products"

// ================= Payment ================= //
export const PAYMENT_RENT_URL = "payment/rent-product"

/************* WORKSHOP *************/
export const WORKSHOP_LIST_URL = "client/workshopers/profiles"
export const WORKSHOP_PROFILE_URL = "client/workshopers"
export const WORKSHOP_PROFILE_SELECT_URL = "/client/workshopers/select"

/************* DESIGNER *************/
export const DESIGNER_REQUEST_FOR_PHONE_NUMBER_URL = "contractors/select-as-designer"

/************* ASSEMBLERS *************/
export const ASSEMBLERS_LIST_URL = "client/assemblers/profiles"
export const ASSEMBLERS_PROFILE_URL = "client/assemblers"
export const ASSEMBLERS_SIGNUP = "assemblers/signup"
export const ASSEMBLERS_PROFILE_SELECT_URL = "assembler/select"
